import { render, staticRenderFns } from "./EllipsisMenuItem.vue?vue&type=template&id=53e98898&scoped=true&"
import script from "./EllipsisMenuItem.vue?vue&type=script&lang=js&"
export * from "./EllipsisMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./EllipsisMenuItem.vue?vue&type=style&index=0&id=53e98898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e98898",
  null
  
)

export default component.exports